module.exports = __webpack_public_path__ + "assets/img/serve5.32290005.png";